// Shared helpers for the citation preview modals (PDF / DOCX / video / file).
//
// Human-readable label for the source-provider tag so the user can see in the
// modal header where the file is actually being fetched from. The wording
// emphasises "your" storage for direct fetches and clarifies when the file
// has to be proxied through Discover (Drive doesn't expose a signed URL).
// Internal storage backends serve files uploaded manually to a knowledge base;
// from the user's perspective these aren't external clouds and shouldn't read
// like one. External connectors keep the "your <provider>" framing.
const PROVIDER_LABELS = {
  s3: "your S3 bucket",
  gcs: "your GCS bucket",
  google_drive: "Google Drive (proxied)",
  rustfs: "the knowledge library",
  minio: "the knowledge library",
  azure_spn: "the knowledge library",
  azure_sas: "the knowledge library",
  oss: "the knowledge library",
};

export function describeSource(source, provider) {
  const label = PROVIDER_LABELS[provider] || provider || "storage";
  if (source === "proxy") return `via Discover (${label})`;
  return label;
}
